import { NgModule } from '@angular/core';
import { LegalEntityInvoiceStoreModule } from './legalEntityPracticeV3Invoices/legalEntityPracticeV3Invoices.module';

@NgModule({
  declarations: [],
  imports: [
    LegalEntityInvoiceStoreModule
  ],
})
export class FormStateStoreModule { }
